var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-45 px-8 bgray-200 gray-600 fw-500 d-flex align-item-center justify-content-between"},[_vm._v(" "+_vm._s(_vm.local_campaign.campaign_name)+" 결과 보고서 ")])}
var staticRenderFns = []

export { render, staticRenderFns }